<template>
	<div class="container">
    <div v-if="this.language == 'de'">
        <p>In unserem Lieferprogramm finden Sie Ger&auml;te und Verbrauchsmaterialien f&uuml;r die Biotechnologie, Mikrobiologie und Molekularbiologie aus unserer Eigenfertigung.<br>
          <br>
          Viele unserer Produkte sind selbsterkl&auml;rend, andere profitieren f&uuml;r den optimalen Einsatz von einer pers&ouml;nlichen Beratung.<br>
          <br>
          Z&ouml;gern Sie nicht, Kontakt mit uns aufzunehmen, wenn Sie spezielle Fragen haben.<br>
          <br>
          <b>schuett-biotec GmbH<br>
          </b>Rudolf-Wissell-Str. 13<br>
          D-37079 G&ouml;ttingen<br>
          <br></p>
          <table>
          <tr>
            <td>Fon:</td>
            <td>+49 (0)551/5 04 10-0</td>
          </tr>
          <tr>
            <td>Fax:</td>
            <td>+49 (0)551/5 04 10-99</td>
          </tr>
          <tr>
            <td>E-Mail:</td>
            <td><a href="mailto:info@schuett-biotec.de">info@schuett-biotec.de</a></td>
          </tr>
        </table>
    </div>
    <div v-if="this.language == 'en'">
      <p>Our product range includes equipment and consumables for biotechnology, microbiology and molecular biology of our own manufacture.<br>
            <br>
            Most of our products are self-explanatory, others can be put to better use following some personal consultation.<br>
            <br>
            Please do not hesitate to contact us, if you have specific questions.<br>
            <br>
            <b>schuett-biotec GmbH<br>
            </b>Rudolf-Wissell-Str. 13<br>
            D-37079 G&ouml;ttingen<br>
            <br>
          </p>
        <table border="0" cellpadding="0" cellspacing="0" width="300">
          <tr>
            <td width="50">Fon:</td>
            <td>+49 (0)551/5 04 10-0</td>
          </tr>
          <tr>
            <td width="50">Fax:</td>
            <td>+49 (0)551/5 04 10-99</td>
          </tr>
          <tr>
            <td width="50">E-Mail:</td>
            <td><a href="mailto:info@schuett-biotec.de">info@schuett-biotec.de</a></td>
          </tr>
        </table>
    </div>
	</div>
</template>
<script>
export default {
    name: 'wiruberuns',
    data () {
      return {}
    }
};
</script>
<style scoped>
	.container {
    color: black;
    margin: 1rem;
  }
  table {
    width: 300px;
  }
</style>


// WEBPACK FOOTER //
// src/components/wiruberuns.vue